<template>
  <div>
    <Overview :facebook-campaign-id="facebookCampaignId" />
  </div>
</template>

<script>
import Overview from './components/Overview.vue';

export default {
  name: 'General',
  components: {
    Overview,
  },
  props: {
    facebookCampaignId: {
      type: String,
      default: null,
    },
  },
};
</script>
